// Lib
import * as _ from 'lodash';
import { put, call, takeLatest } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";

// Functions
import { createAPINetworkInstance } from 'common/api';

// Types
import { ActionGetUrlUpgradePackageAPI, getUrlUpgradeAPIError, getUrlUpgradeAPISuccess, getUrlEliteRedirectAPISuccess } from './actions';

function* getUrlUpgrade(action: ActionGetUrlUpgradePackageAPI) {
    try {
        const connection  = action.connection??"Chatmeter Upsell Redirect";
        const dealerId  = action.dealerId;
        const { data } = yield call(createAPINetworkInstance().get, `/urls/${connection}/dealer/${dealerId}`);
        if (action.connection) yield put(getUrlEliteRedirectAPISuccess(data));
        else yield put(getUrlUpgradeAPISuccess(data));
    } catch (err) {
        yield put(getUrlUpgradeAPIError(err));
    }
}

export default function* urlSagas() {
    yield takeLatest(ACTIONS.GET_URLUPGRADE_PACKAGE_API_REQUEST, getUrlUpgrade);
}
